import { FC } from 'react';

import { AnalyticsEvent, useAnalytics } from '@bonusly/analytics';
import { Box, TabList, TabPanel, TabPanels, Tabs } from '@bonusly/design-system';

import { SpacedSpinner } from '../Loading';
import { HighlightTab } from '../Tabs';
import { useSearchContext } from './context';
import { EmptyState } from './EmptyState';
import { useSearchTabs } from './hooks/useSearchTabs';

// Map tab analyticsKey to AnalyticsEvent
const tabEventMap: Record<string, string> = {
	All: AnalyticsEvent.TopNavbar.AllTabClick,
	Users: AnalyticsEvent.TopNavbar.UsersTabClick,
	Recognitions: AnalyticsEvent.TopNavbar.RecognitionsTabClick,
};

export const SearchBody: FC = () => {
	const { track } = useAnalytics();
	const { hasAnyRecords, isFetching, query } = useSearchContext();

	const tabs = useSearchTabs();

	if (isFetching) {
		return <SpacedSpinner />;
	}

	if (!hasAnyRecords) {
		return <EmptyState />;
	}

	return (
		<>
			<Tabs isLazy>
				{query && (
					<TabList border="none" pos="relative" zIndex={1}>
						{tabs.map((tab) => (
							<HighlightTab
								key={tab.key}
								onClick={() => {
									track(tabEventMap[tab.analyticsKey]);
								}}
							>
								{tab.label}
							</HighlightTab>
						))}
					</TabList>
				)}

				<Box background="gray.50" mb={3} height={0.5} pos="relative" transform="translate(0, -2px)" zIndex={0} />

				<TabPanels>
					{tabs.map((tab) => (
						<TabPanel key={tab.key} p={0}>
							{tab.content}
						</TabPanel>
					))}
				</TabPanels>
			</Tabs>
		</>
	);
};
